import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";

import { makeStyles, Typography } from "@material-ui/core";

import useIcon from "../hooks/useIcon";
import LoadingButton from "../Components/LoadingButton";
import { getBalanceAndSymbol } from "../ethereumFunctions";
import { claimIncome } from "./WithdrawFunctions";
import CachedIcon from "@material-ui/icons/Cached";

import { quoteRemoveLiquidity } from "../Liquidity/LiquidityFunctions";

const useStyles = makeStyles((theme) => ({
  tableHolder: {
    padding: theme.spacing(2),
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
  },

  infoLoadingBTNBox: {
    margin: "0px -8px",
  },
  infoBoxRefreshIcon: {
    fill: `${theme.palette.primary.main}`,
    marginRight: theme.spacing(1),
    cursor: "pointer",
  },
}));

function WithdrawListItem({ network, item, isLast }) {
  const [iconImage] = useIcon();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [balance, setBalance] = useState([0, 0, 0]);
  const [loading, setLoading] = useState(false);
  const [balanceLoading, setBalanceLoading] = useState(false);

  // Determines whether the button should be enabled or not
  const isClaimButtonEnabled = () => {
    // If both coins have been selected, and a valid float has been entered which is less than the user's balance, then return true
    const parsedInput = parseFloat(balance[0]);
    return !isNaN(parsedInput) && 0 < parsedInput;
  };

  const claim = () => {
    console.log("Attempting to token stacking...");
    setLoading(true);

    claimIncome(network.withdraw, network.signer, item.address)
      .then(() => {
        setLoading(false);
        setBalance(0);

        enqueueSnackbar("Claim Income Successful", {
          variant: "success",
          autoHideDuration: 5000,
        });
      })
      .catch((e) => {
        setLoading(false);
        enqueueSnackbar("Claim Income Failed (" + e.reason + ")", {
          variant: "error",
          autoHideDuration: 5000,
        });
      });
  };

  const get_balance = async () => {
    // start loading
    setBalanceLoading(true);

    // request
    await getBalanceAndSymbol(
      network.withdraw,
      item.address,
      network.wethAddress,
      network.coins
    )
      .then(async (data) => {
        if (data) {
          const coin_balance = Number(data.balance)
            .toFixed(+item.decimals)
            .replace(/\.?0+$/, "");

          setBalance(coin_balance);

          if (item.type === "lptoken" && coin_balance) {
            await quoteRemoveLiquidity(
              item.lptokens.token0.address,
              item.lptokens.token1.address,
              coin_balance,
              network.factory,
            )
              .then((res) => {
                setBalance([coin_balance, res[1], res[2]]);
                // stop loading
                setBalanceLoading(false);
              })
              .catch((err) => {
                // stop loading
                setBalanceLoading(false);
              });
          } else {
            // stop loading
            setBalanceLoading(false);
            setBalance([coin_balance, 0, 0]);
          }
        }
      })
      .catch((err) => {
        // stop loading
        setBalanceLoading(false);
      });

    // stop loading
    setBalanceLoading(false);
  };

  useEffect(() => {
    get_balance();
  }, []);

  return (
    <tr>
      <td className="name-icon">
        <div className="d-flex align-items-center">
          <div className="multi-image-box me-2">
            {item.type === "token" ? (
              <img src={iconImage(item.symbol)} alt={item.symbol} />
            ) : (
              <>
                <img
                  src={iconImage(item.lptokens.token0.symbol)}
                  alt={item.lptokens.token0.symbol}
                  className="image1"
                />
                <img
                  src={iconImage(item.lptokens.token1.symbol)}
                  alt={item.lptokens.token1.symbol}
                  className="image4"
                />
              </>
            )}
          </div>

          <Typography variant="body1">
            {item.type === "token"
              ? item.symbol
              : `${item.lptokens.token0.symbol}-${item.lptokens.token1.symbol}`}
          </Typography>
        </div>
      </td>

      <td className="balance">
        <div className="d-flex align-items-center">
          <CachedIcon
            className={`${balanceLoading ? "syncLoading" : ""} ${
              classes.infoBoxRefreshIcon
            }`}
            onClick={() => get_balance()}
          />
          <Typography variant="body1" className="fw-bolder">
            {balance[0]}
          </Typography>
        </div>
        {item.type === "lptoken" && (
          <div>
            <Typography variant="caption">
              {balance[1]
                ? Number(balance[1])
                    .toFixed(+item.lptokens.token0.decimals)
                    .replace(/\.?0+$/, "")
                : 0}{" "}
              {item.lptokens.token0.symbol}
            </Typography>
            {" | "}
            <Typography variant="caption">
              {balance[2]
                ? Number(balance[2])
                    .toFixed(+item.lptokens.token1.decimals)
                    .replace(/\.?0+$/, "")
                : 0}{" "}
              {item.lptokens.token1.symbol}
            </Typography>
          </div>
        )}
      </td>

      <td className="btn-holder">
        <div>
          <div className={classes.infoLoadingBTNBox}>
            <LoadingButton
              loading={loading.harvest}
              valid={isClaimButtonEnabled()}
              success={false}
              fail={false}
              onClick={claim}
            >
              Claim
            </LoadingButton>{" "}
          </div>
        </div>
      </td>
    </tr>
  );
}

export default WithdrawListItem;
